// extracted by mini-css-extract-plugin
export default {"share_box":"index_share_box_Rsf5D"};